import { Component, computed, inject, signal} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { MatBadgeModule } from '@angular/material/badge';
import { AuthService } from '../../../../services/auth.service';
import { AppService } from '../../../../services/app.service';
import { switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-notifications-button',
  imports: [
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatBadgeModule,
    TranslatePipe,
  ],
  templateUrl: './notifications-button.component.html',
  styleUrl: './notifications-button.component.scss'
})

export class NotificationsButtonComponent {
  public readonly badge = computed(() => (this.notificationsCount() > 0) ? this.notificationsCount().toString() : '');
  
  private readonly authService = inject(AuthService);
  private readonly appService = inject(AppService);
  private readonly notificationsCount = signal(0);
  
  
  constructor() {
    this.authService.getEmployeeId().pipe(
      switchMap(employeeId => this.appService.getCount(employeeId)),
      tap(cnt => this.notificationsCount.set(cnt)),
    ).subscribe()
  }
}
